// Wrapper que adaptava o tema MUI conforme idioma (direction e tipografia).
// Em arquitetura Tailwind puro, a direcao e setada em RtlLayout (document.dir)
// e tipografia e definida em src/theme/tokens.css. Este componente vira um
// pass-through que apenas retorna children.

export default function ThemeLocalization({ children }) {
  return <>{children}</>;
}
